/*!
 * JM Language translate fallback v1.0 (v1.32)
 * The Google Cloud Translation key is restricted to jewelledme.com, so on Shopify's preview addresses
 * (…shopifypreview.com, theme editor) Google refuses it and every name stayed on the sample word.
 * If Cloud Translation refuses or fails, we answer the same request with Google Input Tools instead,
 * in the shape jm-lang-preview.js expects. On the live site nothing changes.
 */
(function () {
  'use strict';
  if (window.__jmlpFallback || !window.fetch) return;
  window.__jmlpFallback = true;
  // Cloud Translation target → Google Input Tools code
  var IT = { ar: 'ar', am: 'am', hy: 'hy', bn: 'bn', fa: 'fa', ka: 'ka', el: 'el', gu: 'gu', iw: 'he', hi: 'hi', kn: 'kn', ko: 'ko',
    km: 'km', ml: 'ml', pa: 'pa', ru: 'ru', ta: 'ta', te: 'te', th: 'th', ti: 'ti', uk: 'uk', ur: 'ur' };
  var orig = window.fetch.bind(window), down = false;
  function json(o) { return new Response(JSON.stringify(o), { status: 200, headers: { 'Content-Type': 'application/json' } }); }
  function it(code, word) {
    return orig('https://inputtools.google.com/request?text=' + encodeURIComponent(word.toLowerCase()) + '&itc=' + code +
      '-t-i0-und&num=1&cp=0&cs=1&ie=utf-8&oe=utf-8')
      .then(function (r) { return r.json(); })
      .then(function (j) { return (j[0] === 'SUCCESS' && j[1] && j[1][0] && j[1][0][1] && j[1][0][1][0]) || ''; }, function () { return ''; });
  }
  function fake(url) {
    var u = new URL(url), code = IT[u.searchParams.get('target')], qs = u.searchParams.getAll('q');
    if (!code || !qs.length) return Promise.resolve(json({}));
    return Promise.all(qs.map(function (q) {
      var words = q.split(/\s+/).filter(Boolean);
      return Promise.all(words.map(function (w) { return it(code, w); })).then(function (ws) { return ws.every(Boolean) ? ws.join(' ') : ''; });
    })).then(function (out) {
      return json(out.every(Boolean) ? { data: { translations: out.map(function (s) { return { translatedText: s }; }) } } : {});
    });
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url.indexOf('https://translation.googleapis.com/') !== 0) return orig(input, init);
    if (down) return fake(url);
    return orig(input, init).then(function (r) { if (r.ok) return r; down = true; return fake(url); }, function () { down = true; return fake(url); });
  };
})();
